import type { QueryClient } from "@tanstack/react-query";
import { ClassRoomsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchClassRoomsGet(
  queryClient: QueryClient,
  page: number = 1,
  pageSize: number = 1000,
  active?: boolean,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching class rooms");
  }

  const service = createAuthenticatedApi(ClassRoomsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.ClassRooms, page, pageSize, active],
    queryFn: () =>
      service.apiClassRoomsScrollGet({
        page,
        pageSize,
        active,
      }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}

